import React, {useState, useEffect} from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { Field } from 'react-final-form';
import brainstorm from '../../forms/EditListingServiceInfoForm/images/brainstorm.svg';
import consult from '../../forms/EditListingServiceInfoForm/images/consult.svg'
import editing from '../../forms/EditListingServiceInfoForm/images/editing.svg'
import mock from '../../forms/EditListingServiceInfoForm/images/mock.svg'

import { types as sdkTypes } from '../../util/sdkLoader';
import { propTypes } from '../../util/types';

import css from './FieldCheckbox.module.css';

const sharetribeSdk = require('sharetribe-flex-sdk');


const sdk = sharetribeSdk.createInstance({
    clientId: process.env.REACT_APP_SHARETRIBE_SDK_CLIENT_ID
  });

const { UUID, LatLng } = sdkTypes;


const IconCheckbox = props => {
  const { className, checkedClassName, boxClassName } = props;
  return (
    <svg className={className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(2 2)">
          <path
            className={checkedClassName || css.checked}
            d="M9.9992985 1.5048549l-.0194517 6.9993137C9.977549 9.3309651 9.3066522 10 8.4798526 10H1.5001008c-.8284271 0-1.5-.6715729-1.5-1.5l-.000121-7c0-.8284271.6715728-1.5 1.5-1.5h.000121l6.9993246.0006862c.8284272.000067 1.4999458.671694 1.499879 1.5001211a1.5002208 1.5002208 0 0 1-.0000059.0040476z"
          />
          <path
            className={boxClassName || css.box}
            strokeWidth="2"
            d="M10.9992947 1.507634l-.0194518 6.9993137C10.9760133 9.8849417 9.8578519 11 8.4798526 11H1.5001008c-1.3807119 0-2.5-1.1192881-2.5-2.4999827L-1.0000202 1.5c0-1.3807119 1.119288-2.5 2.500098-2.5l6.9994284.0006862c1.3807118.0001115 2.4999096 1.11949 2.4997981 2.5002019-.0000018.003373-.0000018.003373-.0000096.0067458z"
          />
        </g>
        <path
          d="M5.636621 10.7824771L3.3573694 8.6447948c-.4764924-.4739011-.4764924-1.2418639 0-1.7181952.4777142-.473901 1.251098-.473901 1.7288122 0l1.260291 1.1254782 2.8256927-4.5462307c.3934117-.5431636 1.1545778-.6695372 1.7055985-.278265.5473554.3912721.6731983 1.150729.2797866 1.6951077l-3.6650524 5.709111c-.2199195.306213-.5803433.5067097-.9920816.5067097-.3225487 0-.6328797-.1263736-.8637952-.3560334z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
};


const IconRadio = props => {
  const { className, checkedClassName, boxClassName } = props;
  return (
    <svg className={className} width="14" height="14" xmlns="http://www.w3.org/2000/svg">
      <g fill="none" fillRule="evenodd">
        <g transform="translate(2 2)">
          <path
            className={checkedClassName || css.checked}
            d="M9.9992985 1.5048549l-.0194517 6.9993137C9.977549 9.3309651 9.3066522 10 8.4798526 10H1.5001008c-.8284271 0-1.5-.6715729-1.5-1.5l-.000121-7c0-.8284271.6715728-1.5 1.5-1.5h.000121l6.9993246.0006862c.8284272.000067 1.4999458.671694 1.499879 1.5001211a1.5002208 1.5002208 0 0 1-.0000059.0040476z"
          />
          <path
            className={boxClassName || css.box}
            strokeWidth="2"
            d="M10.9992947 1.507634l-.0194518 6.9993137C10.9760133 9.8849417 9.8578519 11 8.4798526 11H1.5001008c-1.3807119 0-2.5-1.1192881-2.5-2.4999827L-1.0000202 1.5c0-1.3807119 1.119288-2.5 2.500098-2.5l6.9994284.0006862c1.3807118.0001115 2.4999096 1.11949 2.4997981 2.5002019-.0000018.003373-.0000018.003373-.0000096.0067458z"
          />
        </g>
        {/* <path
          d="M5.636621 10.7824771L3.3573694 8.6447948c-.4764924-.4739011-.4764924-1.2418639 0-1.7181952.4777142-.473901 1.251098-.473901 1.7288122 0l1.260291 1.1254782 2.8256927-4.5462307c.3934117-.5431636 1.1545778-.6695372 1.7055985-.278265.5473554.3912721.6731983 1.150729.2797866 1.6951077l-3.6650524 5.709111c-.2199195.306213-.5803433.5067097-.9920816.5067097-.3225487 0-.6328797-.1263736-.8637952-.3560334z"
          fill="#FFF"
        /> */}
      </g>
    </svg>
  );
};

IconCheckbox.defaultProps = { className: null, checkedClassName: null, boxClassName: null };

IconCheckbox.propTypes = { className: string, checkedClassName: string, boxClassName: string };

const FieldCheckboxComponent = props => {

  const publicData = props.listingData;
  const showWarning = props.showWarning;
  const setShowWarning = props.setShowWarning;
  const checkedUnsavedService = props.checkedUnsavedService;
  const setCheckedUnsavedService = props.setCheckedUnsavedService;
  
  const [isCheckedConsultation, setIsCheckedConsultation] = useState(false);
  const [isCheckedBrainstorm, setIsCheckedBrainstorm] = useState(false);
  const [isCheckedPersonalEdit, setIsCheckedPersonalEdit] = useState(false);
  const [isCheckedSecondaryEdit, setIsCheckedSecondaryEdit] = useState(false);
  const [isCheckedMock, setIsCheckedMock] = useState(false);


  //for fake checkboxes
  const [isCheckedConsultationFake, setIsCheckedConsultationFake] = useState(publicData ?  (publicData.consultationPrice ? true : false) : false)
  const [isCheckedBrainstormFake, setIsCheckedBrainstormFake] = useState(publicData ?  (publicData.brainstormPrice ? true : false) : false)
  const [isCheckedPersonalEditFake, setIsCheckedPersonalEditFake] = useState(publicData ?  (publicData.personalStatementEditingPrice ? true : false) : false)
  const [isCheckedSecondaryEditFake, setIsCheckedSecondaryEditFake] = useState(publicData ?  (publicData.secondaryStatementEditingPrice ? true : false) : false)
  const [isCheckedMockFake, setIsCheckedMockFake] = useState(publicData ?  (publicData.mockPrice ? true : false) : false)
  //const [checkedUnsavedService, setCheckedUnsavedService] = useState(false)
  //const [showWarning, setShowWarning] = useState(false)

  //brainstorm checkboxes options



  const {
    rootClassName,
    className,
    svgClassName,
    textClassName,
    id,
    label,
    useSuccessColor,
    service,
    setCheckedService,
    handleServiceChange,
    listingData,
    submitDisabled,
    serviceOption,
    handleChecked,
    listing,
    editingService,
    isConsultationFilledUp,
    setBrainstormCheckboxesFilled,
    isBrainstormPriceSelected,
    brainstormOption1,
    setBrainstormOption1,
    brainstormOption2,
    setBrainstormOption2,
    brainstormOption3,
    setBrainstormOption3,
    brainstormOption4,
    setBrainstormOption4,
    brainstormOption5,
    setBrainstormOption5,
    brainstormOption6,
    setBrainstormOption6,
    personalOption,
    setPersonalOption,
    personalStatementEditingPrice,
    secondaryOption,
    setSecondaryOption,
    secondaryStatementEditingPrice,
    mockOption,
    mockPrice,
    ...rest
  } = props;

  useEffect(() => {

    if(service === "service"){

        
      if(listingData.personalStatementEditingId){
        sdk.ownListings.show({id: listingData.personalStatementEditingId}).then(res => {
          const personalStatementServiceListing = res.data.data;
          return personalStatementServiceListing;
        }).then(resp => {
                if(resp.attributes.state === "closed"){
                  //console.log("personal statement service created but closed")
                  setIsCheckedPersonalEdit(false)
                }else if(resp.attributes.state === "published"){
                  //console.log("personal statement service created and open")
                  setIsCheckedPersonalEdit(true)
                };
        }).catch(error => {console.log(error)});
      }else {
          //console.log(" no personal statement service ever created")
          setIsCheckedPersonalEdit(false)
      };


      if(listingData.consultationId){
        sdk.ownListings.show({id: listingData.consultationId}).then(res => {
          const consultationServiceListing = res.data.data;
          return consultationServiceListing;
        }).then(resp => {
                if(resp.attributes.state === "closed"){
                  //console.log("consultation service created but closed")
                  setIsCheckedConsultation(false)
                }else if(resp.attributes.state === "published"){
                  //console.log("consultation service created and open")
                  setIsCheckedConsultation(true)
                };
        }).catch(error => {console.log(error)});
      }else {
          //console.log(" no consultation service ever created")
          setIsCheckedConsultation(false)
      };


      if(listingData.brainstormId){
        sdk.ownListings.show({id: listingData.brainstormId}).then(res => {
          const brainstormServiceListing = res.data.data;
          return brainstormServiceListing;
        }).then(resp => {
                if(resp.attributes.state === "closed"){
                  //console.log("brainstorm service created but closed")
                  setIsCheckedBrainstorm(false)
                }else if(resp.attributes.state === "published"){
                  //console.log("brainstorm service created and open")
                  setIsCheckedBrainstorm(true)
                };
        }).catch(error => {console.log(error)});
      }else {
          //console.log(" no brainstorm service ever created")
          setIsCheckedBrainstorm(false)
      };


      if(listingData.secondaryStatementEditingId){
        sdk.ownListings.show({id: listingData.secondaryStatementEditingId}).then(res => {
          const secondaryEditServiceListing = res.data.data;
          return secondaryEditServiceListing;
        }).then(resp => {
                if(resp.attributes.state === "closed"){
                  //console.log("secondary edit service created but closed")
                  setIsCheckedSecondaryEdit(false)
                }else if(resp.attributes.state === "published"){
                  //console.log("secondary edit service created and open")
                  setIsCheckedSecondaryEdit(true)
                };
        }).catch(error => {console.log(error)});
      }else {
          //console.log(" no secondary edit service ever created")
          setIsCheckedSecondaryEdit(false)
      };


      
      if(listingData.mockId){
        sdk.ownListings.show({id: listingData.mockId}).then(res => {
          const mockServiceListing = res.data.data;
          return mockServiceListing;
        }).then(resp => {
                if(resp.attributes.state === "closed"){
                  //console.log("mock service created but closed")
                  setIsCheckedMock(false)
                }else if(resp.attributes.state === "published"){
                  //console.log("mock service created and open")
                  setIsCheckedMock(true)
                };
        }).catch(error => {console.log(error)});
      }else {
          //console.log(" no mock service ever created")
          setIsCheckedMock(false)
      };


   

  }

}
, []);


const isSignUp =  id === "service.consultation" && listingData.consultationId ? false : (
  id === "service.personalStatementBrainstorm" && listingData.brainstormId ? false : (
    id === "service.mockInterview" && listingData.mockId ? false : (
      id === "service.personalStatementEditing" && listingData.personalStatementEditingId ? false : (
        id === "service.secondaryStatementEditing" && listingData.secondaryStatementEditingId ? false : true
      )
    )
  )
);     



const handleCheckedOrUnchecked = () => {
  if(id === "service.consultation"){

                      if(isCheckedConsultation && listingData.consultationId){  //HERE ->  && listingData.consultationId
                    sdk.ownListings.close({
                      id: new UUID(listingData.consultationId)
                    }, {
                      expand: true
                    }).then(resp => {


                                    const allPricesArray = [
                                      listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                                      listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                                      listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                                      listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                                ]

                                const getMinimumPrice = (array) => {
                                return Math.min.apply( Math, array );
                                }
                                const minimumPrice = getMinimumPrice(allPricesArray)


                                  return sdk.ownListings.update({
                                        id: new UUID(listing.id.uuid),
                                          price: {
                                            amount: parseInt(minimumPrice)*100,
                                            currency: "USD"
                                          }
                                    }).catch(error => {
                                      console.log("error at updating master listing after secondary statemnt")
                                })


                    }).then(resp => {
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                            const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];

                            const consultationService = masterListingServices.find(service => {
                              return service === "consultation"
                            });
                              let indexOfConsultationService
                            if(consultationService === "consultation"){
                              indexOfConsultationService = masterListingServices.indexOf("consultation")
                            }

                            masterListingServices.splice(indexOfConsultationService, 1)
                            console.log(masterListingServices)

                                return sdk.ownListings.update({
                                  id: new UUID(listing.id.uuid),
                                  publicData: {
                                        services: masterListingServices,
                                    },
                              }).catch(error => {
                                  console.log("error at updating master listing after consultation")
                            })
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%

                    }).then(res => {
                      setIsCheckedConsultation(false)
                      //console.log("closed consultation statement service")
                    }).catch(error => console.log(error));
                  }else if(!isCheckedConsultation && listingData.consultationId){
                        sdk.ownListings.open({
                          id: new UUID(listingData.consultationId)
                        }, {
                          expand: true
                        }).then(resp => {


                          const allPricesArray = [
                            listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                            listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                            listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                            listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                            listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                      ]

                      const getMinimumPrice = (array) => {
                      return Math.min.apply( Math, array );
                      }
                      const minimumPrice = getMinimumPrice(allPricesArray)


                        return sdk.ownListings.update({
                              id: new UUID(listing.id.uuid),
                                price: {
                                  amount: parseInt(minimumPrice)*100,
                                  currency: "USD"
                                }
                          }).catch(error => {
                            console.log("error at updating master listing after secondary statemnt")
                      })


          }).then(resp => {
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                                  const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];
                                  
                                  const consultationService = masterListingServices.find(service => {
                                    return service === "consultation"
                                  });

                                  if(consultationService === undefined){
                                    masterListingServices.push("consultation")
                                  }

                                  console.log(masterListingServices)
                                      return sdk.ownListings.update({
                                        id: new UUID(listing.id.uuid),
                                        publicData: {
                                              services: masterListingServices, 
                                          },
                                    }).catch(error => {
                                        console.log("error at updating master listing after consultation")
                                  })
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                        }).then(res => {
                          setIsCheckedConsultation(true)
                          //console.log("opened consultation statement service")
                        }).catch(error => console.log(error));
                  }else if(!isCheckedConsultation && !listingData.consultationId){          
                    setIsCheckedConsultation(true)                            //HERE -> setIsCheckedConsultation(true) 
                    setCheckedUnsavedService(true)
                    //console.log("no consultation statement service found")
                  }

  }else if(id === "service.personalStatementBrainstorm"){

                  if(isCheckedBrainstorm && listingData.brainstormId){
                    sdk.ownListings.close({
                      id: new UUID(listingData.brainstormId)
                    }, {
                      expand: true
                    }).then(resp => {


                      const allPricesArray = [
                        listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                        listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                        listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                        listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                  ]

                  const getMinimumPrice = (array) => {
                  return Math.min.apply( Math, array );
                  }
                  const minimumPrice = getMinimumPrice(allPricesArray)


                    return sdk.ownListings.update({
                          id: new UUID(listing.id.uuid),
                            price: {
                              amount: parseInt(minimumPrice)*100,
                              currency: "USD"
                            }
                      }).catch(error => {
                        console.log("error at updating master listing after secondary statemnt")
                  })


      }).then(resp => {
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                            const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];

                            const brainstormService = masterListingServices.find(service => {
                              return service === "brainstorm"
                            });
                              let indexOfBrainstormService
                            if(brainstormService === "brainstorm"){
                              indexOfBrainstormService = masterListingServices.indexOf("brainstorm")
                            }

                            masterListingServices.splice(indexOfBrainstormService, 1)
                            console.log(masterListingServices)

                                return sdk.ownListings.update({
                                  id: new UUID(listing.id.uuid),
                                  publicData: {
                                        services: masterListingServices,
                                    },
                              }).catch(error => {
                                  console.log("error at updating master listing after brainstorm")
                            })
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                    }).then(res => {
                      setIsCheckedBrainstorm(false)
                      //console.log("closed brainstorm service")
                    }).catch(error => console.log(error));
                  }else if(!isCheckedBrainstorm && listingData.brainstormId){
                        sdk.ownListings.open({
                          id: new UUID(listingData.brainstormId)
                        }, {
                          expand: true
                        }).then(resp => {


                          const allPricesArray = [
                            listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                            listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                            listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                            listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                            listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                      ]

                      const getMinimumPrice = (array) => {
                      return Math.min.apply( Math, array );
                      }
                      const minimumPrice = getMinimumPrice(allPricesArray)


                        return sdk.ownListings.update({
                              id: new UUID(listing.id.uuid),
                                price: {
                                  amount: parseInt(minimumPrice)*100,
                                  currency: "USD"
                                }
                          }).catch(error => {
                            console.log("error at updating master listing after secondary statemnt")
                      })


          }).then(resp => {
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                                  const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];
                                  
                                  const brainstormService = masterListingServices.find(service => {
                                    return service === "brainstorm"
                                  });

                                  if(brainstormService === undefined){
                                    masterListingServices.push("brainstorm")
                                  }

                                  console.log(masterListingServices)
                                      return sdk.ownListings.update({
                                        id: new UUID(listing.id.uuid),
                                        publicData: {
                                              services: masterListingServices, 
                                          },
                                    }).catch(error => {
                                        console.log("error at updating master listing after brainstorm")
                                  })
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                        }).then(res => {
                          setIsCheckedBrainstorm(true)
                          //console.log("opened brainstorm  service")
                        }).catch(error => console.log(error));
                  }else if(!isCheckedBrainstorm && !listingData.brainstormId){
                    setIsCheckedBrainstorm(true)                
                    setCheckedUnsavedService(true)
                    //console.log("no brainstorm  service found")

                  }

  }else if(id === "service.mockInterview"){

                       if(isCheckedMock && listingData.mockId){
                    sdk.ownListings.close({
                      id: new UUID(listingData.mockId)
                    }, {
                      expand: true
                    }).then(resp => {


                      const allPricesArray = [
                        listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                        listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                        listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                        listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                  ]

                  const getMinimumPrice = (array) => {
                  return Math.min.apply( Math, array );
                  }
                  const minimumPrice = getMinimumPrice(allPricesArray)


                    return sdk.ownListings.update({
                          id: new UUID(listing.id.uuid),
                            price: {
                              amount: parseInt(minimumPrice)*100,
                              currency: "USD"
                            }
                      }).catch(error => {
                        console.log("error at updating master listing after secondary statemnt")
                  })


      }).then(resp => {
 //%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                            const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];

                            const mockService = masterListingServices.find(service => {
                              return service === "mock"
                            });
                              let indexOfMockService
                            if(mockService === "mock"){
                              indexOfMockService = masterListingServices.indexOf("mock")
                            }

                            masterListingServices.splice(indexOfMockService, 1)
                            console.log(masterListingServices)

                                return sdk.ownListings.update({
                                  id: new UUID(listing.id.uuid),
                                  publicData: {
                                        services: masterListingServices,
                                    },
                              }).catch(error => {
                                  console.log("error at updating master listing after mock")
                            })
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                    }).then(res => {
                      setIsCheckedMock(false)
                      //console.log("closed mock statement service")
                    }).catch(error => console.log(error));
                  }else if(!isCheckedMock && listingData.mockId){
                        sdk.ownListings.open({
                          id: new UUID(listingData.mockId)
                        }, {
                          expand: true
                        }).then(resp => {


                          const allPricesArray = [
                            listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                            listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                            listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                            listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                            listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                      ]

                      const getMinimumPrice = (array) => {
                      return Math.min.apply( Math, array );
                      }
                      const minimumPrice = getMinimumPrice(allPricesArray)


                        return sdk.ownListings.update({
                              id: new UUID(listing.id.uuid),
                                price: {
                                  amount: parseInt(minimumPrice)*100,
                                  currency: "USD"
                                }
                          }).catch(error => {
                            console.log("error at updating master listing after secondary statemnt")
                      })


          }).then(resp => {
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                                  const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];
                                  
                                  const mockService = masterListingServices.find(service => {
                                    return service === "mock"
                                  });

                                  if(mockService === undefined){
                                    masterListingServices.push("mock")
                                  }

                                  console.log(masterListingServices)
                                      return sdk.ownListings.update({
                                        id: new UUID(listing.id.uuid),
                                        publicData: {
                                              services: masterListingServices, 
                                          },
                                    }).catch(error => {
                                        console.log("error at updating master listing after mock")
                                  })
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                        }).then(res => {
                          setIsCheckedMock(true)
                          //console.log("opened mock statement service")
                        }).catch(error => console.log(error));
                  }else if(!isCheckedMock && !listingData.mockId){
                    setIsCheckedMock(true)                
                    setCheckedUnsavedService(true)
                    //console.log("no mock statement service found")
                  }

  }else if(id === "service.personalStatementEditing"){

                  if(isCheckedPersonalEdit && listingData.personalStatementEditingId){
                    sdk.ownListings.close({
                      id: new UUID(listingData.personalStatementEditingId)
                    }, {
                      expand: true
                    }).then(resp => {


                      const allPricesArray = [
                        listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                        listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                        listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                        listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                  ]

                  const getMinimumPrice = (array) => {
                  return Math.min.apply( Math, array );
                  }
                  const minimumPrice = getMinimumPrice(allPricesArray)


                    return sdk.ownListings.update({
                          id: new UUID(listing.id.uuid),
                            price: {
                              amount: parseInt(minimumPrice)*100,
                              currency: "USD"
                            }
                      }).catch(error => {
                        console.log("error at updating master listing after secondary statemnt")
                  })


      }).then(resp => {
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                            const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];

                            const personalService = masterListingServices.find(service => {
                              return service === "personal"
                            });
                              let indexOfPersonalService
                            if(personalService === "personal"){
                              indexOfPersonalService = masterListingServices.indexOf("personal")
                            }

                            masterListingServices.splice(indexOfPersonalService, 1)
                            console.log(masterListingServices)

                                return sdk.ownListings.update({
                                  id: new UUID(listing.id.uuid),
                                  publicData: {
                                        services: masterListingServices,
                                    },
                              }).catch(error => {
                                  console.log("error at updating master listing after personal")
                            })
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                    }).then(res => {
                      setIsCheckedPersonalEdit(false)
                      //console.log("closed personal statement service")
                    }).catch(error => console.log(error));
                  }else if(!isCheckedPersonalEdit && listingData.personalStatementEditingId){
                        sdk.ownListings.open({
                          id: new UUID(listingData.personalStatementEditingId)
                        }, {
                          expand: true
                        }).then(resp => {


                          const allPricesArray = [
                            listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                            listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                            listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                            listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                            listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                      ]

                      const getMinimumPrice = (array) => {
                      return Math.min.apply( Math, array );
                      }
                      const minimumPrice = getMinimumPrice(allPricesArray)


                        return sdk.ownListings.update({
                              id: new UUID(listing.id.uuid),
                                price: {
                                  amount: parseInt(minimumPrice)*100,
                                  currency: "USD"
                                }
                          }).catch(error => {
                            console.log("error at updating master listing after secondary statemnt")
                      })


          }).then(resp => {
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                                  const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];
                                  
                                  const personalService = masterListingServices.find(service => {
                                    return service === "personal"
                                  });

                                  if(personalService === undefined){
                                    masterListingServices.push("personal")
                                  }

                                  console.log(masterListingServices)
                                      return sdk.ownListings.update({
                                        id: new UUID(listing.id.uuid),
                                        publicData: {
                                              services: masterListingServices, 
                                          },
                                    }).catch(error => {
                                        console.log("error at updating master listing after personal")
                                  })
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                        }).then(res => {
                          setIsCheckedPersonalEdit(true)
                          //console.log("opened personal statement service")
                        }).catch(error => console.log(error));
                  }else if(!isCheckedPersonalEdit && !listingData.personalStatementEditingId){
                    setIsCheckedPersonalEdit(true)                
                    setCheckedUnsavedService(true)
                    //console.log("no personal statement service found")
                  }

  }else if(id === "service.secondaryStatementEditing"){

                      if(isCheckedSecondaryEdit && listingData.secondaryStatementEditingId){
                    sdk.ownListings.close({
                      id: new UUID(listingData.secondaryStatementEditingId)
                    }, {
                      expand: true
                    }).then(resp => {


                      const allPricesArray = [
                        listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                        listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                        listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                        listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                  ]

                  const getMinimumPrice = (array) => {
                  return Math.min.apply( Math, array );
                  }
                  const minimumPrice = getMinimumPrice(allPricesArray)


                    return sdk.ownListings.update({
                          id: new UUID(listing.id.uuid),
                            price: {
                              amount: parseInt(minimumPrice)*100,
                              currency: "USD"
                            }
                      }).catch(error => {
                        console.log("error at updating master listing after secondary statemnt")
                  })


      }).then(resp => {
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                            const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];

                            const secondaryService = masterListingServices.find(service => {
                              return service === "secondary"
                            });
                              let indexOfSecondaryService
                            if(secondaryService === "secondary"){
                              indexOfSecondaryService = masterListingServices.indexOf("secondary")
                            }

                            masterListingServices.splice(indexOfSecondaryService, 1)
                            console.log(masterListingServices)

                                return sdk.ownListings.update({
                                  id: new UUID(listing.id.uuid),
                                  publicData: {
                                        services: masterListingServices,
                                    },
                              }).catch(error => {
                                  console.log("error at updating master listing after secondary")
                            })
//%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                    }).then(res => {
                      setIsCheckedSecondaryEdit(false)
                      //console.log("closed secondary statement service")
                    }).catch(error => console.log(error));
                  }else if(!isCheckedSecondaryEdit && listingData.secondaryStatementEditingId){
                        sdk.ownListings.open({
                          id: new UUID(listingData.secondaryStatementEditingId)
                        }, {
                          expand: true
                        }).then(resp => {


                          const allPricesArray = [
                            listingData.brainstormPrice ? parseInt(listingData.brainstormPrice) : 999999,
                            listingData.consultationPrice ? parseInt(listingData.consultationPrice) : 999999,
                            listingData.mockPrice ? parseInt(listingData.mockPrice) : 999999,
                            listingData.personalStatementEditingPrice ? parseInt(listingData.personalStatementEditingPrice) : 999999,
                            listingData.secondaryStatementEditingPrice ? parseInt(listingData.secondaryStatementEditingPrice) : 999999
                      ]

                      const getMinimumPrice = (array) => {
                      return Math.min.apply( Math, array );
                      }
                      const minimumPrice = getMinimumPrice(allPricesArray)


                        return sdk.ownListings.update({
                              id: new UUID(listing.id.uuid),
                                price: {
                                  amount: parseInt(minimumPrice)*100,
                                  currency: "USD"
                                }
                          }).catch(error => {
                            console.log("error at updating master listing after secondary statemnt")
                      })


          }).then(resp => {
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                                  const masterListingServices = listing.attributes.publicData.services ? listing.attributes.publicData.services : [];
                                  
                                  const secondaryService = masterListingServices.find(service => {
                                    return service === "secondary"
                                  });

                                  if(secondaryService === undefined){
                                    masterListingServices.push("secondary")
                                  }

                                  console.log(masterListingServices)
                                      return sdk.ownListings.update({
                                        id: new UUID(listing.id.uuid),
                                        publicData: {
                                              services: masterListingServices, 
                                          },
                                    }).catch(error => {
                                        console.log("error at updating master listing after secondary")
                                  })
// %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
                        }).then(res => {
                          setIsCheckedSecondaryEdit(true)
                          //console.log("opened secondary statement service")
                        }).catch(error => console.log(error));
                  }else if(!isCheckedSecondaryEdit && !listingData.secondaryStatementEditingId){
                    setIsCheckedSecondaryEdit(true)                
                    setCheckedUnsavedService(true)
                    //console.log("no secondary statement service found")
                  }

  }                                  
        
}



const handleFakeCheck = (input, event) => {

if(id === "service.consultation"){
  const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);

  handleServiceChange("consultation")
  setIsCheckedConsultationFake(!isCheckedConsultationFake) 
  setCheckedService("consultation")

}else if(id === "service.personalStatementBrainstorm"){
  const { onBlur, onChange } = input;
  onChange(event);
  onBlur(event);
  
  handleServiceChange("personalStatementBrainstorm")
  setIsCheckedBrainstormFake(!isCheckedBrainstormFake)
  setCheckedService("personalStatementBrainstorm")
  
}else if(id === "service.mockInterview"){
  const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);

  handleServiceChange("mockInterview")
  setIsCheckedMockFake(!isCheckedMockFake)
  setCheckedService("mockInterview")

}else if(id === "service.personalStatementEditing"){
  const { onBlur, onChange } = input;
  onChange(event);
  onBlur(event);

  handleServiceChange("personalStatementEditing")
  setIsCheckedPersonalEditFake(!isCheckedPersonalEditFake)
  setCheckedService("personalStatementEditing")

}else if(id === "service.secondaryStatementEditing"){
  const { onBlur, onChange } = input;
  onChange(event);
  onBlur(event);
 
  handleServiceChange("secondaryStatementEditing")
  setIsCheckedSecondaryEditFake(!isCheckedSecondaryEditFake)
  setCheckedService("secondaryStatementEditing")
}
}


  const classes = classNames(rootClassName || css.root, className);
  // This is a workaround for a bug in Firefox & React Final Form.
  // https://github.com/final-form/react-final-form/issues/134
  const handleOnChangeService = (input, event) => {
    const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);
    setCheckedService(event.target.value)
    handleServiceChange(event.target.value)
    
  };

  const handleGuidelinesCheck = (input, event) => {
    const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);
    handleChecked()
  };

  

  const handleOnChange = (input, event) => {
    const { onBlur, onChange } = input;
    onChange(event);
    onBlur(event);
    // console.log(event.target.checked)
    // console.log(id)
    //handle brainstorm service checkboxes group on signup
    const isChecked = event.target.checked;
    const isBrainstormCheckboxes = id === "brainstorm.formulate" || id === "brainstorm.go" || id === "brainstorm.discuss" || id === "brainstorm.discuss1" || id === "brainstorm.share" || id === "brainstorm.other";
    const isPersonalStatementCheckboxes = id === "personalStatementEditing.1r" || id === "personalStatementEditing.2r";
    const isSecondaryStatementCheckboxes = id === "secondaryStatementEditing.1r" || id === "secondaryStatementEditing.2r";
    if(isSignUp){

                                if(isBrainstormCheckboxes){

                                                  if(id === "brainstorm.formulate"){
                                                      setBrainstormOption1(!brainstormOption1)
                                                  } 
                                                  else if(id === "brainstorm.go"){
                                                          setBrainstormOption2(!brainstormOption2)

                                                  } else if(id === "brainstorm.discuss"){
                                                          setBrainstormOption3(!brainstormOption3)

                                                  } else if(id === "brainstorm.discuss1"){
                                                          setBrainstormOption4(!brainstormOption4)

                                                  } else if(id === "brainstorm.share"){
                                                          setBrainstormOption5(!brainstormOption5)

                                                  } else if(id === "brainstorm.other"){
                                                          setBrainstormOption6(!brainstormOption6)

                                                  }


                                }else if(isPersonalStatementCheckboxes){
                                                if(id === "personalStatementEditing.1r" || id === "personalStatementEditing.2r"){
                                                        setPersonalOption(true)
                                                }
                                }else if(isSecondaryStatementCheckboxes){
                                                if(id === "secondaryStatementEditing.1r" || id === "secondaryStatementEditing.2r"){
                                                         setSecondaryOption(true)
                                                  }
                                  
                                }
          
          }
  };

  const fieldOnChange = service === "service" ? handleOnChangeService : ( handleChecked ? handleGuidelinesCheck :  handleOnChange);



  const successColorVariantMaybe = useSuccessColor
    ? {
        checkedClassName: css.checkedSuccess,
        boxClassName: css.boxSuccess,
      }
    : {};

    const brainstormPricing = isBrainstormPriceSelected === "" || isBrainstormPriceSelected === 'NaN' ? false : true;
    const isAnyBrainstormCheckboxChecked = brainstormOption1 || brainstormOption2 || brainstormOption3 || brainstormOption4 || brainstormOption5 || brainstormOption6;
    const isBrainstormFilledUp = isAnyBrainstormCheckboxChecked && brainstormPricing;
    const isBrainstormHalfFilledUp = (isAnyBrainstormCheckboxChecked && !brainstormPricing) || (!isAnyBrainstormCheckboxChecked && brainstormPricing);


    const personalPricing = personalStatementEditingPrice === "" || personalStatementEditingPrice === 'NaN' ? false : true;
    const isAnyPersonalStatementCheckboxChecked = personalOption;
    const isPersonalFilledUp = isAnyPersonalStatementCheckboxChecked && personalPricing;
    const isPersonalHalfFilledUp = (isAnyPersonalStatementCheckboxChecked && !personalPricing )|| (!isAnyPersonalStatementCheckboxChecked && personalPricing);

    const secondaryPricing = secondaryStatementEditingPrice === "" || secondaryStatementEditingPrice === 'NaN' ? false : true;
    const isAnySecondaryStatementCheckboxChecked = secondaryOption;
    const isSecondaryFilledUp = isAnySecondaryStatementCheckboxChecked && secondaryPricing;
    const isSecondaryHalfFilledUp = (isAnySecondaryStatementCheckboxChecked && !secondaryPricing )|| (!isAnySecondaryStatementCheckboxChecked && secondaryPricing);

    const mockPricing = mockPrice === "" || mockPrice === 'NaN' ? false : true;
    const isAnyMockCheckboxSelected = mockOption;
    const isMockFilledUp = isAnyMockCheckboxSelected && mockPricing;
    const isMockHalfFilledUp = (mockPricing && !isAnyMockCheckboxSelected) || (!mockPricing && isAnyMockCheckboxSelected);


    const isConsultationComplete =  isConsultationFilledUp === "" || isConsultationFilledUp === 'NaN' ? false : true;
  
    // console.log(publicData)

    const isSignupFinished = publicData ? (publicData.consultationId || publicData.brainstormId || publicData.personalStatementEditingId || publicData.secondaryStatementEditingId || publicData.mockId) : true;
      
    const imagesBeforeSignUp = id === "service.consultation" ? (
      <img src={consult} className={isConsultationComplete ? css.serviceChecked : css.serviceNotChecked}/>
        ) : (
          id === "service.personalStatementBrainstorm" ? (
            <img src={brainstorm} className={isBrainstormFilledUp ? css.serviceChecked : isBrainstormHalfFilledUp ? css.serviceHalfChecked : css.serviceNotChecked}/>
              ) : (
                    id === "service.mockInterview" ? (
                            <img src={mock} className={isMockFilledUp ? css.serviceChecked : isMockHalfFilledUp ? css.serviceHalfChecked : css.serviceNotChecked}/>
                      ) : (

                        id === "service.personalStatementEditing" ? 
                              <img src={editing} className={isPersonalFilledUp ? css.serviceChecked : isPersonalHalfFilledUp ? css.serviceHalfChecked : css.serviceNotChecked}/>  :   
                                      <img src={editing} className={isSecondaryFilledUp ? css.serviceChecked : isSecondaryHalfFilledUp ? css.serviceHalfChecked : css.serviceNotChecked}/>
                      )
              )
            );

           

   const imagesAfterSignUp = id === "service.consultation" ? (
              <img src={consult} className={isCheckedConsultation ? css.serviceChecked : css.serviceNotChecked} />
                ) : (
                  id === "service.personalStatementBrainstorm" ? (
                    <img src={brainstorm} className={isCheckedBrainstorm ? css.serviceChecked : css.serviceNotChecked}/>
                      ) : (
                            id === "service.mockInterview" ? (
                                    <img src={mock} className={isCheckedMock ? css.serviceChecked : css.serviceNotChecked}/>
                              ) : (

                                id === "service.personalStatementEditing" ? 
                                      <img src={editing} className={isCheckedPersonalEdit ? css.serviceChecked : css.serviceNotChecked}/>  :   
                                              <img src={editing} className={isCheckedSecondaryEdit ? css.serviceChecked : css.serviceNotChecked}/>
                              )
                      )
                    )

    const serviceLabel =   id === "service.consultation" ? (
      <label htmlFor={"service.consultation"} className={css.consultationLabel}>Consultation</label>
        ) : (
          id === "service.personalStatementBrainstorm" ? (
            <label htmlFor={"service.personalStatementBrainstorm"}>Personal statement brainstorm</label>
              ) : (
                    id === "service.mockInterview" ? (
                      <label  htmlFor={"service.mockInterview"}>Mock interview</label>
                      ) : (
                          id === "service.personalStatementEditing" ? (
                             <label htmlFor={"service.personalStatementEditing"}>Personal statement editing</label>
                                ) : (
                                  id === "service.secondaryStatementEditing" ? (
                                    <label  htmlFor={"service.secondaryStatementEditing"}>Secondary statement editing</label>
                                       ) : (
                                        id === "service.letterOfIntent" ? (
                                          <label htmlFor={"service.letterOfIntent"}>Letter of intent</label>
                                             ) : (
                                               <label></label>
                                             ) 
                                       ) 
                                ) 
                      )
              )
            )   

    const isChecked =  id === "service.consultation" ? (
      isCheckedConsultation
        ) : (
          id === "service.personalStatementBrainstorm" ? (
            isCheckedBrainstorm
              ) : (
                    id === "service.mockInterview" ? (
                      isCheckedMock
                      ) : (
                          id === "service.personalStatementEditing" ? (
                            isCheckedPersonalEdit
                                ) : (
                                  id === "service.secondaryStatementEditing" ? (
                                    isCheckedSecondaryEdit
                                       ) : false
                                ) 
                      )
              )

            ) 



            const isCheckedFake =  id === "service.consultation" ? (
              isCheckedConsultationFake
                ) : (
                  id === "service.personalStatementBrainstorm" ? (
                    isCheckedBrainstormFake
                      ) : (
                            id === "service.mockInterview" ? (
                              isCheckedMockFake
                              ) : (
                                  id === "service.personalStatementEditing" ? (
                                    isCheckedPersonalEditFake
                                        ) : (
                                          id === "service.secondaryStatementEditing" ? (
                                            isCheckedSecondaryEditFake
                                               ) : false
                                        ) 
                              )
                      )
        
                    ) 

                                 
      const showCheckbox =  id === "service.consultation" && listingData.consultationId ? true : (
        id === "service.personalStatementBrainstorm" && listingData.brainstormId ? true : (
          id === "service.mockInterview" && listingData.mockId ? true : (
            id === "service.personalStatementEditing" && listingData.personalStatementEditingId ? true : (
              id === "service.secondaryStatementEditing" && listingData.secondaryStatementEditingId ? true : false
            )
          )
        )
      )
      
     


    const fieldType = editingService === true ? "radio" : (service === "service" ? "radio" : "checkbox");
    const fieldLabel = service === "service" ? (
      <label htmlFor={id} className={css.serviceLabel}>

        <div className={css.insideLabelWrapper}>

       {showCheckbox ? <input className={css.serviceCheckbox} type="checkbox" checked={isChecked} onClick={handleCheckedOrUnchecked}></input> : 
       
        // <Field type={"checkbox"} {...rest}>
        // {props => {
        //   const input = props.input;
        //   return (
        //     <input
        //       id={id}
        //       type="checkbox"
        //       checked={isCheckedFake}
        //       // {...input}
        //       onChange={event => handleFakeCheck(input, event)}
        //     />
        //   );
        // }}

        // </Field>
        null
        }
       
       
       {/* <input type="checkbox" checked={isChecked} onClick={handleFakeCheck}></input>}  */}
        
        {isSignupFinished ? imagesAfterSignUp : imagesBeforeSignUp}
        </div>

      </label>
    ) : (
      <label htmlFor={id} className={css.label}>
        <span className={fieldType === "radio" ? css.radioWrapper : css.checkboxWrapper}>
        {fieldType === "radio" ? <IconRadio className={svgClassName} {...successColorVariantMaybe} /> : <IconCheckbox className={svgClassName} {...successColorVariantMaybe} />}
          
        </span>
        <span className={classNames(css.text, textClassName || css.textRoot)}>{label}</span>
      </label>
    )
  return (
    
    <span className={classes}>
      <Field type={fieldType} {...rest}>
        {props => {
          const input = props.input;
          return (
            <input
              id={id}
              className={css.input}
              {...input}
              onChange={event => fieldOnChange(input, event)}
            />
          );
        }}
      </Field>
      {fieldLabel}
      {service === "service" ? serviceLabel : null}
      {/* <label htmlFor={id} className={css.label}>
        <span className={css.checkboxWrapper}>
          <IconCheckbox className={svgClassName} {...successColorVariantMaybe} />
        </span>
        <span className={classNames(css.text, textClassName || css.textRoot)}>{label}</span>
      </label> */}
    </span>
  );
};

FieldCheckboxComponent.defaultProps = {
  className: null,
  rootClassName: null,
  svgClassName: null,
  textClassName: null,
  label: null,
};

FieldCheckboxComponent.propTypes = {
  className: string,
  rootClassName: string,
  svgClassName: string,
  textClassName: string,

  // Id is needed to connect the label with input.
  id: string.isRequired,
  label: node,

  // Name groups several checkboxes to an array of selected values
  name: string.isRequired,

  // Checkbox needs a value that is passed forward when user checks the checkbox
  value: string.isRequired,
};

export default FieldCheckboxComponent;
